 // Whole Component Tejashwini
import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Divider,
} from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import Layout from "./layout";
import axios from "axios";
import RefundedProductsDialog from "./RefundedProductsDialog"; // Import Dialog Component
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import TablePagination from "@mui/material/TablePagination";
import Box from "@mui/material/Box";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

export default function RefundLogForm({ studentID, studentName ,handleCloseModal}) {
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'student_id', direction: 'desc' });
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);  
  
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
    cursor: "pointer",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    // backgroundColor: theme.palette.action.hover,
    cursor: "pointer",
  },
  "&:active": {
    backgroundColor: theme.palette.action.selected,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
  useEffect(() => {
    getRefunded();
  }, [studentID]);

  const getRefunded = async () => {
    if (!studentID) {
      console.error("Error: studentID is undefined");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/refundLogForm/getRefund`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_id: studentID }),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok. Status: ${response.status}`);
      }

      const result = await response.json();
      setRows(result);
    } catch (error) {
      console.error("Error fetching payment summary:", error.message);
    }
  };

  const getRefundlogListproduct = async (studentID, refund_type_id,refund_ID ) => {
    if (!studentID) {
      console.error("Error: studentID is undefined");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/refundLogForm/getRefundlogListproducts`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ student_id: studentID, refund_type_id,refund_ID }),
        }
      );

      if (!response.ok) {
        throw new Error(`Network response was not ok. Status: ${response.status}`);
      }

      const result = await response.json();
      setSelectedRows(Array.isArray(result) ? result : []);
      setOpenDialog(true);
    } catch (error) {
      console.error("Error fetching refund log data:", error.message);
    }
  };

  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };
  const handleGradeChange = (event) => {
    setSelectedGrade(event.target.value);
  };

  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  
  // Helper function to get nested values safely
  const getNestedValue = (obj, key) => {
    return key.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
  
  const sortedRows = React.useMemo(() => {
    const sortableRows = [...rows];
  
    if (sortConfig.key) {
      sortableRows.sort((a, b) => {
        let valueA = getNestedValue(a, sortConfig.key);
        let valueB = getNestedValue(b, sortConfig.key);
  
        // Handle undefined values
        if (valueA === undefined) valueA = "";
        if (valueB === undefined) valueB = "";
  
        // Convert values to lowercase if they are strings (for case-insensitive sorting)
        if (typeof valueA === "string") valueA = valueA.toLowerCase();
        if (typeof valueB === "string") valueB = valueB.toLowerCase();
  
        if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
  
    return sortableRows;
  }, [rows, sortConfig]);
  
  
  const filteredRows = React.useMemo(() => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);
  
    return sortedRows.filter((row) => {
      const matchesSearchTerms = searchTerms.every((term) =>
        (row.refund_id && row.refund_id.toString().toLowerCase().includes(term)) ||
        (row.RefundType.refund_type_name && row.first_name.toLowerCase().includes(term)) ||
        (row.last_name && row.last_name.toLowerCase().includes(term)) ||
        (row.father_name && row.father_name.toLowerCase().includes(term)) ||
        (row.mother_name && row.mother_name.toLowerCase().includes(term)) ||
        (row.email_id && row.email_id.toLowerCase().includes(term)) ||
        (row.contact_no && row.contact_no.toString().includes(term)) ||
        (row.fee_slab_id && row.fee_slab_id.toString().toLowerCase().includes(term))
      );
  
      return (
        (selectedGrade === "" || row.grade_id === selectedGrade) &&
        (selectedSection === "" || row.section_id === selectedSection) &&
        matchesSearchTerms
      );
    });
  }, [sortedRows, selectedGrade, selectedSection, searchQuery]);
  
  const paginatedRows = React.useMemo(() => {
    return filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredRows, page, rowsPerPage]);
  

  return (
    <>
      <Layout />
      <Box
  sx={{
    width: "85%",         // Increased width
    height: "auto",       // Or specify a fixed height like "300px" if needed
    position: "fixed",
    left: "8em",          // Adjusted slightly for center alignment
    top: "190px",         // Adjusted for better vertical spacing
    padding: "20px",      // Added padding for internal spacing
    backgroundColor: "#f9f9f9", // Optional: background for the box itself
    borderRadius: "8px",  // Softer rounded corners
    boxShadow: "0px 4px 10px rgba(0,0,0,0.15)", // Enhanced shadow
  }}
>
      <Typography
        variant="h5"
        component="h2"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          color: "#0A64A2",
          // marginY: "0.0px",
          backgroundColor: "",
          padding: "15px",
          fontSize:'1.7em'
          // borderRadius: "3px",
          // boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        Refund Logs for {studentName}
      </Typography>
    
      <IconButton aria-label="close refund logs" sx={{position: 'absolute',right: 9,top: 1,color: (theme) => theme.palette.grey[500],}}onClick={handleCloseModal}>
  <CloseIcon />
</IconButton>


      <TableContainer
        component={Paper}
        sx={{
          height: paginatedRows.length > 6 ? "500px" : "fit-content", // Set height only if rows > 6
          maxHeight: paginatedRows.length > 6 ? "340px" : "auto",  // Restrict max height after 6 rows
          width: "100%",
          overflowY: paginatedRows.length > 6 ? "auto" : "hidden", // Enable scroll only if rows > 6
          display: "flex",
          flexDirection: "column",
        }}
      >

        <Table stickyHeader>
        <TableHead sx={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#0A64A2" }}>
  <TableRow>
    {[
      { label: "Refund ID", key: "refund_id" },
      { label: "Refund Type", key: "RefundType.refund_type_name" },  // Nested property
      { label: "Refund Date", key: "refund_date" },
      { label: "Created By", key: "created_by" },
      { label: "Description", key: "description" },
      { label: "Refund Amount", key: "refund_amount" },
    ].map(({ label, key }, index) => (
      <StyledTableCell key={index} sx={{ backgroundColor: "#0A64A2", color: "white", textAlign: "center" }}>
        {key ? (
          <TableSortLabel
            active={sortConfig.key === key}
            direction={sortConfig.key === key ? sortConfig.direction : "asc"}
            onClick={() => handleSort(key)}
            sx={{ 
              color: "white", 
              "&:hover": { color: "#000" }, // Change hover color to black
              "&.Mui-active": { color: "white" } // Keep the active color white
            }}
          >
            {label}
          </TableSortLabel>

        ) : (
          label
        )}
      </StyledTableCell>
    ))}
  </TableRow>
</TableHead>

          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((row, index) => (
                <TableRow key={row.refund_id || index}>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.refund_id ? row.refund_id : "N/A"}
                  </TableCell>
                  {/* <TableCell style={{ textAlign: "center" }}>{row.student_id}</TableCell> */}
                  <TableCell style={{ textAlign: "center" }}>{row.RefundType?.refund_type_name}</TableCell>
                  <TableCell style={{ textAlign: "center" }}>{row.refund_date}</TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.createdByUser
                      ? `${row.createdByUser.first_name} ${row.createdByUser.last_name}`
                      : "N/A"}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>{row.description}</TableCell>
                  <TableCell
                     style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      minWidth: "180px",
                    }}
                    >  
                      <span                      
                        style={{
                          display: "inline-block",
                          minWidth: "100px", // Fixed width ensures alignment
                          textAlign: "right",
                          marginLeft: "10px", // Slightly adjust left position                    
                          fontVariantNumeric: "tabular-nums", // Equal spacing for digits
                        }}
                      >
                        {row.refund_amount}
                      </span>

                      {row.RefundType?.refund_type_name === "Inventory" && (
                        <InfoIcon
                          style={{ 
                            color: "#0A64A2", 
                            cursor: "pointer", 
                            marginLeft: "5px", // Slightly adjust left position 
                          }} 
                          onClick={() => getRefundlogListproduct(row.student_id, row.refund_type_id, row.refund_id)}
                        />
                      )}
                    </TableCell>
                    </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} style={{ textAlign: "center", padding: "20px", fontSize: "110%" }}>
                  No Refund Log Available.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        sx={{
          background: "#0A64A2",
          color: "#fff",
          width: "100%",
          position: "sticky",
          bottom: 0,
          zIndex: 2,
        }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>



      <RefundedProductsDialog open={openDialog} handleClose={() => setOpenDialog(false)} rows={selectedRows} />
    </>
  );
}
